import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {FiltersService} from "./filters.service";

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {
  form: FormGroup;

  orderFilterForm: FormGroup;


  constructor(public fb: FormBuilder, private FiltersService:FiltersService) {
    // this.FiltersService.getClickEvent().subscribe(res=>{
    //   this.clearFilters();
    // })
  }
  clearFilters(){
    this.form = this.fb.group({
      id: null,
      clientName: [null,],
    });
    this. orderFilterForm = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
    });
  }
  ngOnInit(): void {
    this.clearFilters();
  }

  search() {
    const id = this.form.controls?.id.value
    const clientName = this.orderFilterForm.controls?.clientName.value

    this.FiltersService.sendClickEvent({
      id: id,
      startDate: clientName,
    });
  }

  clear() {
    this.clearFilters();
  }
}
